import { useInResiStore } from "@superbright/indexeddb-orm";
import { type UseQueryOptions } from "@tanstack/react-query";

import { type PropertyResponse, PropertyResponseSchema } from "api/schemas";
import { useParams } from "shared/Router";
import { buildUrl, useQuery } from "utils";
import { inresiHttpService } from "utils/http";

// Query key factory
export const getPropertyQueryKey = (propertySlug: string | undefined) => [
  "property",
  propertySlug,
];

// Query factory
export const getPropertyQuery = (propertySlug: string | undefined) => ({
  queryKey: getPropertyQueryKey(propertySlug),
  queryFn: async (): Promise<PropertyResponse> => {
    if (!propertySlug) throw new Error("No propertySlug provided");
    const response = await inresiHttpService.get<PropertyResponse>(
      buildUrl(`embed/${propertySlug}`),
      { schema: PropertyResponseSchema }
    );
    const store = useInResiStore.getState();
    await store.setCurrentPropertyId(String(response.data.id));
    return response;
  },
});

// The hook uses useParams and wires it up
export const usePropertyQuery = (
  slug: string | undefined,
  options?: UseQueryOptions<PropertyResponse>
) => {
  const { propertySlug } = useParams();

  return useQuery({
    ...getPropertyQuery(propertySlug),
    ...options,
    enabled: !!propertySlug,
  });
};
